module.exports = __webpack_public_path__ + "img/carshina22_17.8882cd73.jpg";